"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _FormAddonAddornament = _interopRequireDefault(require("../FormAddonAddornament/FormAddonAddornament"));

var _FormAddonElementLeft = _interopRequireDefault(require("../FormAddonElementLeft/FormAddonElementLeft"));

var _FormAddonElementRight = _interopRequireDefault(require("../FormAddonElementRight/FormAddonElementRight"));

var _FormControlGroupContext = _interopRequireDefault(require("../FormControlGroupContext/FormControlGroupContext"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var propTypes = {
  /**
   * The content (FormControl and Addons).
   */
  children: _propTypes.node.isRequired,

  /**
   * Size to send to all children of type addon and field.
   */
  size: (0, _propTypes.oneOf)(Object.values(sizes)),

  /**
   * Override or extend the styles applied to the component.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  size: sizes.md,
  classes: {
    root: null
  }
};
var FormControlGroup = (0, _system["default"])('div')({
  label: 'FormControlGroup'
}, {
  position: 'relative',
  alignItems: 'center',
  display: 'flex',
  boxSizing: 'border-box'
}, (0, _system.classesStyles)('root'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "size"]);

  var childrens = _react.Children.toArray(children);

  var pushLeft = false;
  var pushRight = false;
  var noneRadiusLeft = false;
  var noneRadiusRight = false;
  childrens.forEach(function (child) {
    if (child.type === _FormAddonElementLeft["default"]) {
      pushLeft = true;
    }

    if (child.type === _FormAddonElementRight["default"]) {
      pushRight = true;
    }
  });

  if (childrens[0] && childrens[0].type === _FormAddonAddornament["default"]) {
    noneRadiusLeft = true;
  }

  if (childrens[childrens.length - 1] && childrens[childrens.length - 1].type === _FormAddonAddornament["default"]) {
    noneRadiusRight = true;
  }

  var context = (0, _react.useMemo)(function () {
    return {
      size: size,
      pushLeft: pushLeft,
      pushRight: pushRight,
      noneRadiusLeft: noneRadiusLeft,
      noneRadiusRight: noneRadiusRight
    };
  }, [size, pushLeft, pushRight, noneRadiusLeft, noneRadiusRight]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormControlGroup, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlGroupContext["default"].Provider, {
      value: context,
      children: childrens
    })
  }));
});
Component.displayName = 'FormControlGroup';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=FormControlGroup.js.map